import { HttpRequest, HttpEvent, HttpHandlerFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthService } from '../services/auth.service';
import { ConfigService } from 'src/app/infrastructure/services/config-services/config.service';
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';

export function jwtUrlInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const __authService = injectRequired(AuthService);
  const __configService = injectRequired(ConfigService);

  // safe, want loadConfig() is al klaar via AppInitializer
  const __token = __authService.Token;
  const __url = request.url;
  const __rootApi = __configService.rootApi$$();
  const __isApiUrl = !!__rootApi && __url.includes(__rootApi);

  if (__token && __isApiUrl) {
    request = request.clone({ url: __url, setHeaders: { Authorization: `Bearer ${__token}` } });
  }

  return next(request);
}